import styled from 'styled-components';

export const ScrollToTopButton = styled.button`
	background-color: ${({ theme }) => theme.colors.control.dark};
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 42px;
	transition: background-color 0.2s;
	align-self: flex-end;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	&:hover {
		background-color: ${({ theme }) => theme.colors.control.darkHover};
	}
`;
